module.exports = __webpack_public_path__ + "assets/img/产品特色-背景.3baa5be5.jpg";